// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K7Y-","question":"styles_question__1GKxU","description":"styles_description__1cdKB"};